import React from "react";
import { Wrench, Gauge, Settings, Disc, Cog, Droplet, ClipboardCheck, AlertCircle, ArrowRight } from "lucide-react";
import { IMAGES, WHATSAPP_URL } from "../lib/business";

const SERVICES = [
  { icon: Settings, title: "Mecânica Geral" },
  { icon: Gauge, title: "Diagnóstico Eletrônico" },
  { icon: Disc, title: "Freios e Suspensão" },
  { icon: Cog, title: "Motor e Câmbio" },
  { icon: Droplet, title: "Troca de Óleo" },
  { icon: ClipboardCheck, title: "Revisão Rápida" },
  { icon: Wrench, title: "Pequenos Reparos" },
  { icon: AlertCircle, title: "Emergência Mecânica" },
];

export default function CentroAutomotivo() {
  return (
    <section
      id="centro-automotivo"
      data-testid="centro-automotivo-section"
      className="relative py-16 md:py-28 overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0 -z-10">
        <img
          src={IMAGES.porsche}
          alt="Centro automotivo Refúgio Guincho em Araçoiaba da Serra"
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/90 to-[#0A0A0A]/50" />
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 relative">
        <div className="max-w-3xl mb-12">
          <div className="inline-block bg-white text-black px-3 py-1 mb-4">
            <span className="font-anton text-sm uppercase tracking-widest">Diferencial Exclusivo</span>
          </div>
          <h2 className="font-anton text-4xl md:text-6xl lg:text-7xl uppercase text-white leading-[0.95] mb-6">
            Quebrou? Além do Guincho,
            <br />
            <span className="text-[#E50914]">Solução Completa.</span>
          </h2>
          <p className="font-work text-lg md:text-xl text-zinc-200 leading-relaxed mb-4">
            Não fazemos apenas a remoção. Se seu veículo precisar de reparo, diagnóstico ou manutenção, levamos diretamente para o nosso <strong className="text-white">Centro Automotivo</strong> — economizando seu tempo, dinheiro e dor de cabeça.
          </p>
          <p className="font-work text-base text-zinc-300 leading-relaxed">
            Do reboque ao reparo, tudo em um só lugar. Uma equipe. Um preço justo. Sem repasse para terceiros.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mb-10">
          {SERVICES.map((s, i) => (
            <div
              key={s.title}
              data-testid={`centro-auto-card-${i}`}
              className="bg-black/70 backdrop-blur-sm border-2 border-zinc-800 hover:border-[#E50914] p-4 md:p-5 hover-lift transition-all group"
            >
              <s.icon className="w-7 h-7 md:w-8 md:h-8 text-[#E50914] mb-3" strokeWidth={2} />
              <div className="font-anton text-base md:text-lg text-white uppercase leading-tight">
                {s.title}
              </div>
            </div>
          ))}
        </div>

        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="centro-auto-cta"
          className="inline-flex items-center gap-3 bg-[#E50914] hover:bg-[#B80710] text-white font-anton uppercase text-lg md:text-xl tracking-wider px-8 py-4 transition-all hover:-translate-y-1 rounded-sm"
        >
          Falar com a Mecânica agora
          <ArrowRight className="w-5 h-5" strokeWidth={2.5} />
        </a>
      </div>
    </section>
  );
}
